import { defaultColors } from '../../Services/contexts/ServicesChartsDataContext';

const useGaugeChart = ({ chartData, subtitles, colors, series }) => {
    // Pegamos apenas os valores numéricos para o Apex
    const seriesData = series ?? subtitles.map((label) => {
        return chartData.find(d => d.description === label)?.total || 0;
    });

    const seriesDataSubtitles = seriesData.map((value) => `${value.toString().replace('.', ',')}%`);

    const chartConfig = {
        series: seriesData,
        options: {
            chart: {
                type: 'donut',
                sparkline: { enabled: true },
                selection: { enabled: false },
            },
            labels: seriesDataSubtitles,
            colors: defaultColors || [], 
            plotOptions: {
                pie: {
                    startAngle: -90,
                    endAngle: 90,
                    offsetY: 30,
                    donut: {
                        size: '70%',
                        labels: {
                            show: true,
                            name: {
                                show: false
                            },
                            value: {
                                show: true,
                                fontSize: '52px',
                                fontWeight: '400',
                                color: '#616161',
                                offsetY: -25, 
                                formatter: (val) => `${val.toString().replace('.', ',')}%`
                            },
                            total: {
                                show: true,
                                showAlways: true,
                                label: '',
                                formatter: (w) => {
                                    const val = w.globals.series[0];
                                    return `${val.toString().replace('.', ',')}%`;
                                }
                            }
                        }
                    }
                }
            },
            stroke: {
                width: 0
            },
            dataLabels: { enabled: false },
            tooltip: { enabled: false },
            states: {
                hover: { filter: { type: 'none' } },
                active: {
                    allowMultipleDataPointsSelection: false,
                    filter: { type: 'none', value: 0 }
                }
            }
        }
    };

    return { chartConfig };
};

export default useGaugeChart;